import React from 'react';
import Modal from '../../../../shared/modal';
import Button from '../../../../shared/button';


interface IIntegrationDetailsModal {
    openModal: boolean;
    data: any;
    handleCloseModal: () => void;
}

const IntegrationDetailsModal = ({
    openModal,
    data,
    handleCloseModal,
}: IIntegrationDetailsModal) => {

    const onCloseModal = () => {
        handleCloseModal();
    }
    const dataKeys = data?.data && Object?.keys(data?.data)
    return (
        <Modal
            open={openModal}
            showInRight
            contentContainerStyle='!min-w-[100vw] md:!min-w-[650px]'
            onClose={onCloseModal}>
            <div className={'p-2 min-w-[95vw] md:min-w-[600px]'}>
                <p className='mb-4 font-semibold text-sm'>Integration Details</p>
                <div className='bg-[#e4ede657] rounded-[6px] p-3 my-9'>
                    <div className='grid grid-cols-1 gap-2'>
                        <div className='mb-4'>
                            <p className='font-bold'>Name</p>
                            <p>{data?.name}</p>
                        </div>
                        {dataKeys && dataKeys?.length > 0 && dataKeys?.map((item: any) => {
                            return (
                                <div className='mb-4'>
                                    <p className='font-bold'>{item}</p>
                                    <p>{data?.data?.item || ''}</p>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className='min-w-[100%] flex flex-row justify-center'>
                    <Button
                        label={'Close'}
                        className={'btn-primary-rounded-less my-9 min-w-full !shadow-none'}
                        type='submit'
                        onClickButton={onCloseModal}
                    />
                </div>
            </div>
        </Modal>
    )
}
export default IntegrationDetailsModal;